// Helper function to parse boolean from environment variables
const parseEnvBoolean = (value) => {
  if (typeof value === 'boolean') return value;
  if (typeof value === 'string') {
    return value.toLowerCase() === 'true';
  }
  return false;
};

export const features = {
  abha: {
    // Parse the environment variable strictly as a boolean
    enabled: parseEnvBoolean(process.env.VUE_APP_ENABLE_ABHA)
  }
};

/**
 * Check if ABHA feature is enabled
 * @returns {boolean} true if ABHA is enabled, false otherwise
 */
export const isAbhaEnabled = () => {
  const envValue = parseEnvBoolean(process.env.VUE_APP_ENABLE_ABHA);
  console.log('ABHA Feature Check:', {
    envVariable: process.env.VUE_APP_ENABLE_ABHA,
    parsedValue: envValue,
    featuresConfig: features.abha.enabled
  });
  return envValue;
};

export default features;